

































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { GSU_STEP_NAME_MAPPER } from './GSUConstants';
@Component
export default class RoleSelection extends Vue {
  $wlToastr: any;
  private selectedRole = '';
  mounted() {
    vxm.users.fetchUserRoles();
  }

  get userRoles() {
    return vxm.users.UserRoles;
  }

  async onNext() {
    const payload = this.userRoles.find(
      (role) => this.selectedRole === role.roleId,
    );
    if (payload) {
      const response = await vxm.users.saveUserRole(payload);
      if (response.meta.success) {
        await vxm.users.fetchWizardSteps();
        const steps = vxm.users.ProfileWizardSteps.map((step) => {
          const updatedStepName = step.stepName.replace(/_/, '-').toLowerCase();
          const stepNameMapper = GSU_STEP_NAME_MAPPER;
          return stepNameMapper[updatedStepName] || updatedStepName;
        });

        this.$emit('update-role-selected', true);
        this.$emit('update-sections', steps);
      }
    } else {
      this.$wlToastr('error', 'Please select a role to proceed');
    }
  }
}
